module.exports = __webpack_public_path__ + "img/53-r.eb1b03ec.png";